import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';


function FriendlyIndicator() {
    return (
        <div className="friendly-indicator-container">
            <FamilyRestroomIcon className="icon" />
        </div>
    )
}

export default FriendlyIndicator;